import api from '@/interface/baseApi'

//获取品类
export function getCategory() {
    return api({
        url: '/oms/pmall/product/product/getCategory',
        method: 'get',
        params:{}
    })
}

//获取SKU列表
export function getSkus(params) {
    return api({
        url: '/oms/pmall/product/product/getSkus',
        method: 'get',
        params:{
        	page: ('page' in params) ? params.page : 1,
			psize: ('psize' in params) ? params.psize : 20,
			kws: ('kws' in params) ? params.kws : '',
			orby: ('orby' in params) ? params.orby : '',
			sort: ('sort' in params) ? params.sort : '',
			categoryId: ('categoryId' in params) ? params.categoryId : '',
        }
    })
}

